import React from "react";
import s from './Music.module.css';


export const Music =() => {
    return (
        <div>
            Music
            <div>
            <span> Kanye West - Amazing</span>
                <div>
            <span> P Money - This year </span>
                </div>
                <div>
            <span> System of a down - Aerials </span>
                </div>
            </div>
        </div>
    )
}